import { useRef } from "react";
export default function useEditorRef() {
    return useRef(null);
};
